import React, { useContext, useEffect, useState } from 'react';
import { SearchContext } from '../../hooks/SearchContext';
import { FaSearch} from 'react-icons/fa';

import api from '../../services/api';

import { Container } from './styles';

const Search = ({ placeholder, component, qField, qField2 }) => {

  const { handleList } = useContext(SearchContext);

  const [search, setSearch] = useState("");
  const [value, setValue] = useState(false);
  const [componentArray, setComponentArray] = useState([]);

  const token = localStorage.getItem('@Ocariot:token');

  useEffect(() => {
    if(component == "mission") setValue(true)
    if (search !== "") {
      api.get(`${component}`, {
        params: {
          populate: "goals",
          filter: { q: [search], qField: [qField] }
        },
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then(res => {

        handleList(res.data.data, search);
        setComponentArray([...componentArray, ...res.data.data])

      })
        .catch(err => {
          console.log('erro', err);
        })
    } else setTimeout(() => {
      handleList([]);
    }, 500);

  }, [search]);


  return (
    <Container>
      <FaSearch color='rgba(3, 191, 202)'/>
      <input
        type="search"
        className="search"
        placeholder={placeholder}
        onChange={(e) => setSearch(e.target.value.toLowerCase())}
      />
    </Container>
  );
}

export default Search;